import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { API }                               from '../api/api.constant';
import { ApiService }                        from '../api/api.service';
import { InvoiceItemModel }                  from '../invoices/models/invoice.item';
import { InvoiceModel }                      from '../invoices/models/invoice';
import { SessionService }                    from '../sessions/session.service';
import { VehicleHistoryComponent }           from './vehicle.history.component';
import { VehicleHistoryReportComponent }     from './vehicle.history.report.component';
import { VehicleHistoryReportSettingsModel } from './models/vehicle.history.report-settings';
import { VehicleModel }                      from './models/vehicle';

@Injectable({ providedIn: 'root' })
export class VehicleHistoryService {
  tableSettings = {
    pagination: {
      enabled  : true,
      pageSize : 5,
      pageSizes: [ 5, 10, 25, 50 ]
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    }
  };

  constructor (
    private apiService    : ApiService,
    private modalService  : NgbModal,
    private sessionService: SessionService
  ) {}

  copyInvoice ( invoice : InvoiceModel ) : Promise<InvoiceModel> {
    return this.apiService.get('invoice/copy_invoice', invoice.id)
    .then(( invoice : InvoiceModel ) => {
      this.sessionService.setKey('invoice_copy', invoice);

      return invoice;
    });
  }

  getCount ( vehicle : VehicleModel ) : Promise<number> {


    return this.apiService.get('/vehicles/invoice_count', [ vehicle.id, true ]);


  }

  getFirstPage ( vehicle : VehicleModel ) : Promise<Array<InvoiceModel>> {
    return this.getInvoices(vehicle, {
      offset   : 0,
      pageSize : this.tableSettings.pagination.pageSize,
      field    : this.tableSettings.sorting.field,
      direction: this.tableSettings.sorting.direction
    });
  }

  getInvoiceItems ( invoice : InvoiceModel, params : any ) : Promise<Array<InvoiceItemModel>> {
    return this.apiService.get('/invoice_items/invoice_items_list', [
      invoice.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]);
  }

  getInvoiceItemsCount ( invoice : InvoiceModel ) : Promise<number> {


    return this.apiService.get('/invoice_items/invoice_items_list_count', [ invoice.id ]);


  }

  getInvoices ( vehicle : VehicleModel, params : any ) : Promise<Array<InvoiceModel>> {
    return this.apiService.get('/vehicles/invoice_list', [
      vehicle.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      true
    ]);
  }

  search ( vehicle : VehicleModel, params : any, filter : any ) : Promise<Array<InvoiceModel>> {
    return this.apiService.get('/vehicles/invoice_list_with_find', [
      vehicle.id,
      filter,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]);
  }

  searchCount ( vehicle : VehicleModel, filter : any ) : Promise<number> {


    return this.apiService.get('/vehicles/invoice_count_with_find', [
      vehicle.id,
      filter
    ]);


  }

  view ( vehicle : VehicleModel ) : Promise<any> {
    return this.getFirstPage(vehicle)
    .then(( invoices : Array<InvoiceModel> ) => {
      const modal = this.modalService.open(VehicleHistoryComponent, { windowClass: 'x-lg-modal flip-container' });
      modal.componentInstance.invoices = invoices;
      modal.componentInstance.vehicle  = vehicle;
      return modal.result;
    });
  }

  viewReport ( vehicle : VehicleModel ) : Promise<VehicleModel> {
    return this.modalService.open(VehicleHistoryReportComponent).result
    .then(( settings : VehicleHistoryReportSettingsModel ) => {
      window.open(`${ API.url }/reports/jasper_vehicle_history/${ vehicle.id }/${ settings.printTotal }/${ settings.showSummary }.pdf`, '_blank');

      return vehicle;
    });
  }
}
